module.exports = __webpack_public_path__ + "static/media/logo-deco.9d4d7869.png";